import React from 'react';
import NhiemVuTTXM from './NhiemVuTTXM.jsx';
import { ShowIf } from 'components/utils';
import { Link, browserHistory } from 'react-router';
import { TextMessage } from 'components/tt-forms/common';
import {ContainerFileDinhKem} from 'components/upload';
import { connect } from 'react-redux';
import {BlockGiaiQuyetDonInfo} from 'modules/giai-quyet-don/subView';

class KetQuaCanBoGiaiQuyetYeuCauLapDuThao extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      id: this.props.id,
      role: this.props.role,
      coQuanQuanLyNguoiDung: this.props.coQuanQuanLyNguoiDung,
      data: this.props.dataLichSuGiaiQuyet
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.id != nextProps.id && nextProps.id) {
      this.setState({
        id: nextProps.id,
        role: nextProps.role,
        coQuanQuanLyNguoiDung: nextProps.coQuanQuanLyNguoiDung,
        data: nextProps.dataLichSuGiaiQuyet
      })
    }
  }

  onClickClose() {
    if (typeof this.props.handleBack == 'function') {
      this.props.handleBack();
    } else {
      browserHistory.goBack();
    }
  }

  render() {

    return (
      <section className="wrap-block">
        <NhiemVuTTXM
          donViGiaoThamTraXacMinh={this.props.donViGiaoThamTraXacMinhInfo}
          ngayBatDauTTXM={this.props.ngayBatDauTTXM}
          yKienCuaDonViGiaoTTXM = {this.props.yKienCuaDonViGiaoTTXM}
          ngayHetHanTTXM={this.props.ngayHetHanTTXM}
          donInfo = {this.props.donInfo}
          lanhDaoView={this.props.lanhDaoView == true ? true : false}
        />
        <div className="wrap-big-line pt5 pb15">
          <span className="big-border"></span>
        </div>
        <BlockGiaiQuyetDonInfo donInfo={this.props.donInfo} thongTinGQD={this.props.thongTinGQD}/>

        <ShowIf condition={this.props.role != 'truongPhongKiemTraDeXuat'}>
          <h2 className="title-14 mb15">Thông tin giải quyết</h2>
        </ShowIf>
        <div className="form-action">
          <div className="row pl10 pr10">
            <TextMessage className="col-100 mt5 mb10" label='Tóm tắt nội dung kết quả đối thoại:' value={this.props.noiDungKetLuanDuThao ? this.props.noiDungKetLuanDuThao : ''}/>
            <div className="col-100 pb5">
              <ContainerFileDinhKem label="Danh sách văn bản xử lý" hideDescription={true} bindValidator={this} dataShow={this.props.listTaiLieuVanThuGiaiQuyetDon} disableAttachFile={true}/>
            </div>
          </div>
          <ShowIf condition={this.props.lanhDaoView != true}>
            <div className="box-bottom">
              <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
            </div>
          </ShowIf>
        </div>
      </section>
    );
  }
}

export default connect()(KetQuaCanBoGiaiQuyetYeuCauLapDuThao);


// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/KetQuaCanBoGiaiQuyetYeuCauLapDuThao.jsx